import styled from "@emotion/styled";
import React from "react";
import InversionSlider from "./InversionSlider";

const EditInversion = () => {
  return (
    <Wrapper>
      <InversionSlider />
    </Wrapper>
  );
};

export default EditInversion;

const Wrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  margin-top: 55px;
  box-sizing: border-box;
  width: 100%;
  z-index: 2;
`;
